<template>
  <div id="contact-other-form">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: Form Layout -->
        <div class="intro-y box p-5">

          <div class="mt-3">
            <label for="name" class="form-label"><span class="text-danger">*</span> 項目名稱</label>
            <textarea v-model="form.name" id="name" class="form-control w-full"></textarea>
            <div v-if="'name' in errors" class="text-danger mt-2" v-html="errors.name"></div>
          </div>

          <div class="mt-3">
            <label for="address" class="form-label">E-mail / Address</label>
            <textarea v-model="form.address" id="address" class="form-control w-full"></textarea>
            <div v-if="'address' in errors" class="text-danger mt-2" v-html="errors.address"></div>
          </div>

          <div class="mt-3">
            <label for="phone" class="form-label">Tel. No.</label>
            <textarea v-model="form.phone" id="phone" class="form-control w-full"></textarea>
            <div v-if="'phone' in errors" class="text-danger mt-2" v-html="errors.phone"></div>
          </div>

          <div class="mt-3">
            <label for="fax" class="form-label">Fax. No.</label>
            <textarea v-model="form.fax" id="fax" class="form-control w-full"></textarea>
            <div v-if="'fax' in errors" class="text-danger mt-2" v-html="errors.fax"></div>
          </div>

          <div class="mt-3">
            <label for="display_order" class="form-label">顯示次序</label>
            <input v-model="form.display_order" id="display_order" type="number" class="form-control w-full" placeholder="請輸入顯示次序">
            <div v-if="'display_order' in errors" class="text-danger mt-2" v-html="errors.display_order"></div>
          </div>

          <div class="flex justify-end align-items-center mt-5">
            <router-link v-if="!loading && !finish" to="/management/contact-others" type="button" class="btn btn-outline-secondary w-24 mr-1">取消</router-link>
            <button v-if="!loading && !finish" type="button" class="btn btn-primary w-24" @click="onSave">儲存</button>
            <span v-show="loading && !finish"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
        </div>
        <!-- END: Form Layout -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      mode: 'create',
      form: {
        name: null,
        address: null,
        phone: null,
        fax: null,
        display_order: null
      },
      errors: {},
      loading: false,
      finish: false
    }
  },
  watch: {
    data(val) {
      this.init()
    }
  },
  mounted() {
    window.tailwind.svgLoader()
    this.init()
  },
  methods: {
    init() {
      if (this.data != null) {
        this.form = this.data
        this.mode = 'update'
      }
    },
    onSave: async function() {
      this.loading = true
      this.errors = {}

      let response

      if (this.mode === 'create') {
        response = await this.createContactOther(this.form)
      } else {
        response = await this.updateContactOther(this.data.other_id, this.form)
      }

      if ('errors' in response.data) {
        this.errors = response.data.errors
        this.loading = false
      } else {
        let option = {
          title: (this.mode === 'create') ? '已成功新增項目' : '已成功更新項目',
          message: '請稍後，將會轉至項目頁面',
          type: 'success'
        }

        if (response.code === 0) {
          this.finish = true

          setTimeout(() => {
            this.$router.push('/management/contact-others')
          }, 1000)
        } else {
          this.loading = false
          option = {
            title: (this.mode === 'create') ? '未能新增項目' : '未能更新項目',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
